<template>
<div class="expired-container animated fadeInUp">
  <v-flex tag="h3">{{$t('view.expiredPwd.title')}}</v-flex>
  <v-subheader>{{$t('view.expiredPwd.instructions')}}</v-subheader>
  <form role="form" v-on:submit.prevent @keyup.enter="changePassword">
    <v-text-field 
      prepend-icon="lock" 
      name="password" 
      :disabled="view.action.changePassword.busy"
      v-model="$v.auth.password.$model" 
      :error-messages="$t(`validator.${getFirstError($v.auth.password)}.text`,'')"
      :label="$t('view.expiredPwd.password.placeholder')"
      type="password"></v-text-field>
    <!-- <div class="input-group m-b"
      :class="[hasErrors($v.auth.password)?'has-error':'']">
      <span class="input-group-addon signin--i"><i class="icon-append fa fa-lock"></i></span> 		
      <input type="password" 
        class="form-control signin--lock"
        v-model="$v.auth.password.$model" 
        :disabled="view.action.changePassword.busy"
        :placeholder="$t('view.expiredPwd.password.placeholder')">
    </div>
    <label class="error--text" for="password"
      v-if="hasErrors($v.auth.password)">
      {{$t(`validator.${getFirstError($v.auth.password)}.text`,"")}}
    </label> -->
    <v-text-field 
      prepend-icon="lock" 
      name="password" 
      :disabled="view.action.changePassword.busy"
      v-model="$v.auth.newpassword.$model" 
      :error-messages="$t(`validator.${getFirstError($v.auth.newpassword)}.text`,'')"
      :label="$t('view.expiredPwd.newpassword.placeholder')"
      type="password"></v-text-field>
    <!-- <div class="input-group m-b"
      :class="[hasErrors($v.auth.newpassword)?'has-error':'']">
      <span class="input-group-addon signin--i"><i class="icon-append fa fa-lock"></i></span> 			
      <input type="password" 
        class="form-control signin--lock"
        v-model="$v.auth.newpassword.$model" 
        :disabled="view.action.changePassword.busy"
        :placeholder="$t('view.expiredPwd.newpassword.placeholder')">
    </div>
    <label class="error--text" for="password"
       v-if="hasErrors($v.auth.newpassword)">
       {{$t(`validator.${getFirstError($v.auth.newpassword)}.text`,"")}}
    </label> -->
    <v-text-field 
      prepend-icon="lock" 
      name="password" 
      :disabled="view.action.changePassword.busy"
      v-model="$v.auth.confirmpassword.$model" 
      :error-messages="$t(`validator.${getFirstError($v.auth.confirmpassword)}.text`,'')"
      :label="$t('view.expiredPwd.confirmpassword.placeholder')"
      type="password"></v-text-field>
    <!-- <div class="input-group m-b"
      :class="[hasErrors($v.auth.confirmpassword)?'has-error':'']">
      <span class="input-group-addon signin--i"><i class="icon-append fa fa-lock"></i></span> 				
      <input type="password" 
        class="form-control signin--lock"
        v-model="$v.auth.confirmpassword.$model" 
        :disabled="view.action.changePassword.busy"
        :placeholder="$t('view.expiredPwd.confirmpassword.placeholder')">
    </div> -->
    <label class="error--text" for="password"
        v-if="hasErrors($v.auth.confirmpassword)">
      {{getConfirmPasswordErrorDescription}}
      </label>
    <div class="form-group">
      <label class="error--text" 
        v-if="view.elem.label.changePasswordError.visible">
        {{errorChangePasswordMessage}}
      </label>
      <v-btn 
        :disabled="hasErrors($v.auth) || view.action.changePassword.busy" 
        name="loginSubmit"
        @submit="changePassword()"
        @click="changePassword()"
        block 
        color="primary">
          {{$t('view.expiredPwd.submit')}}
      </v-btn>
      <!-- <button type="button"
        class="btn btn-primary full-width m-t-n-xs signin--ingresar" 
        :disabled="hasErrors($v.auth) || view.action.changePassword.busy"
        v-on:click="changePassword()" >
        <strong>{{$t('view.expiredPwd.submit')}}</strong>
      </button> -->
    </div>
  </form>
</div>
</template>
<script>

import Auth from "@/services/auth";
import * as actions from "@/constants/mutation-names";
import transform from "@/helpers/transformations";
import {AuthenticationModel} from "@/models/authentication";
import VueContentLoading from 'vue-content-loading';
import {required, minLength, sameAs} from "vuelidate/lib/validators";
import {allValidatorMethods} from "@/helpers/vuelidate";
import {valueIsWithin} from "@/helpers/validators";
import {errors} from "@/locales/languages/es_MX";

// List of errors required for changing password flow
const errorsChangePassword = Object.keys(errors.changePassword);
//Element's Settings
const label = {
  changePasswordError:{
    visible:false
    , text : ""
  }
};
const button = {
  changePassword:{
    enable:true
  }
};
//Action's state
const action = {
  changePassword:{
    busy:false
  }
};

export default {
  name: "ExpiredPassword",
  head: {
    title: function() {
      return {
        inner       : this.view.title
        , separator : '|'
        , complement: this.$t("view.home.system.initials")
      };
    }
  }
  , data() {
    return {
      auth: undefined
      , locale : this.$i18n.language
      , view: {
        title: "Cambio Contraseña"
        , action
        , elem:{
          label
          , button
        }
      }
    
    };
  }
  , methods:{
    ...allValidatorMethods
    ,  async changePassword() {
      try{
        console.log('ChangePassword')
        // Hide any previous error
        this.hideErrorChangePassword();
        // Validate all models before make the request
        if(!this.isAllValid(this.$v)){
          return;
        }
        //Making request.
        this.view.action.changePassword.busy=true;
        const response = await Auth.changePassword(this.auth);
        this.view.action.changePassword.busy=false;
        // Managing the response
        let {data:{results:{token:userToken, usuario, roles}}} = response;
        const data = {...transform.ResponseToUserStore(usuario), userToken, roles};
        this.$store.dispatch(actions.AUTH_LOGIN,data);
        this.$userPermission.set({roles});
        this.$router.push("/home");
      }catch(error){
        this.view.action.changePassword.busy=false;
        if(error && (error.status=="500" || error.status=="504")){
          this.showErrorChangePassword(this.$t(`network.errors.${error.status}.desc`));
          return;
        }
        //Gettin the code error
        const {data:{meta:{code:errorCode}}} = error;
        if(valueIsWithin(errorsChangePassword,errorCode))
          this.showErrorChangePassword(this.$t(`errors.changePassword.${errorCode}.text`));  
      }
    }
    , showErrorChangePassword(message){
      this.view.elem.label.changePasswordError.visible=true;
      this.view.elem.label.changePasswordError.text=message;
    }
    , hideErrorChangePassword(){
      if(!this.view.elem.label.changePasswordError.visible)
        return;
      this.view.elem.label.changePasswordError.visible=false;
      this.view.elem.label.changePasswordError.text="";
    }
    , setInitialState(username){
      this.auth = new AuthenticationModel();
      this.auth.username = username;
      this.view.elem.label.changePasswordError.visible=true;
      this.view.elem.label.changePasswordError.text="";
    }
  }
  ,computed:{
    errorChangePasswordMessage(){
      return this.view.elem.label.changePasswordError.text
    }
    , getConfirmPasswordErrorDescription(){
      const sameAs = (parameters)=>{
        return "Ambas contraseñas deben coincidir"
      }
      return this.getFirstErrorDescription(this.$v.auth.confirmpassword,{sameAs})
    }
  }
  , validations:{
    auth:{
      password:{
        required
      }
      , newpassword:{
        required
      }
      , confirmpassword:{
        required
        , sameAs: sameAs('newpassword')
      }
    }
  }
  , components:{
    VueContentLoading
  }
  , created() {
    if(this.$route.params.username){
      this.setInitialState(this.$route.params.username)
    }else{
      this.$router.push("/401Unauthorized");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.expired-container{
  position:relative;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/authentication/ExpiredPassword.vue